// extracted by mini-css-extract-plugin
export default {"addToCartControl":"m2-z","giftCard":"n2-z","btnContainer":"o2-z","cartButton":"p2-z","disabled":"q2-z"};